<template>
     <a-drawer
      title="梯度分析"
      placement="right"
      :closable="true"
      :visible="hidden"
      :width="1100"
      :destroyOnClose="true"
      :forceRender="true"
      :bodyStyle="bodyStyle"
      :wrapStyle="wrapStyle"
      wrapClassName="drawer"
      @close="onClose"
    >
    <div class="drawer-box" style="width:100%;height:100%">
      <div style="margin:40px 80px;">
      <a-steps :current="current" size="small">
        <a-step :title="item" :key="index" v-for="(item,index) in steps"/>
      </a-steps>
      </div>
      <div ref="containers" class="containers" style="width:100%;height: calc(100vh - 240px);">
        <analyse-form ref="analyseForm" @next="postAnalyse" v-show="current == 0" />
        <analyse-base ref="analyseBase" :res="result" v-if="current == 1" />
        <analyse-result :result="result" v-if="current == 2" />
      </div>
    </div>
      <div class="footer">
        <a-row justify="space-between" align="middle" type="flex">
          <a-space>
            <a-button @click="onClose">关闭</a-button>
            <a-button v-if="current == 1" @click="exportData">导出</a-button>
          </a-space>
          <a-space>
            <a-button type="primary" @click="prevStep" v-if="current !== 0">上一步</a-button>
            <a-button type="primary" :loading="analyseLoading" @click="nextStep" v-if="current !== this.steps.length - 1">{{current === 0 ? '开始分析' : '下一步'}}</a-button>
          </a-space>
        </a-row>
      </div>
       <progress-modal  :t="3000" />
    </a-drawer>
</template>

<script>
import AnalyseForm from '../analyse/AnalyseForm.vue'
import AnalyseResult from '../analyse/AnalyseResult.vue'
import AnalyseBase from '../analyse/AnalyseBase.vue'
import { formulaMixins } from '../unitls'

import {getRequest} from '@/components/Common/Utils/Utils'
import ProgressModal from "@/components/Formula/modal/ProgressModal.vue";

export default {
  components: {ProgressModal, AnalyseResult, AnalyseForm, AnalyseBase },
  props:['hidden'],
  mixins:[formulaMixins],
  data(){
    return {
      steps:['填写基础信息','组成成分'],
      current: 0,
      result:{},
      secQuestData:{},
      analyseLoading:false,
      containerHeight:500,
      wrapStyle:{
        overflow:'hidden'
      },
      bodyStyle:{
        overflow:'hidden',
      },
      taskId: getRequest('id')
    }
  },
  watch:{
    hidden(){
      this.current = 0
    },
  },

  mounted(){
    this.current = 0
  },

  methods:{
    accMul(arg1,arg2) {
      var m=0,s1=arg1.toString(),s2=arg2.toString();
      try{m+=s1.split(".")[1].length}catch(e){console.log(e)}
      try{m+=s2.split(".")[1].length}catch(e){console.log(e)}
      return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
    },
    async postSecAnalyse(){
      this.secQuestData.algorithmType = 7
      this.result = {}
      let res = await this.fetchPost({
        actions:this.asyncReCalTaskLadderBySpeedOptimization,
        showMessage:false,
        loading:'analyseLoading',
        data:this.secQuestData
      })
      this.secQuestData = {}
      if(res === 'ok') {
         this.getDetail()
      }else {
        // this.$message.warn('配方无解')
        this.$warning({
          title: '优化失败',
          // content: <div><span style="color: red;">配方无解,</span>请检查配方中原料或者营养需要量</div>,
          content:res.msg,
          okText: '确定'
        })
      }
    },
    async postAnalyse(data){
      data.taskId = this.taskId
      data.algorithmType = 6
      data.optimizationType = 1
      this.secQuestData = data
      this.result = {}
      let res = await this.fetchPost({
        actions:this.ladderAnalysisFormulaTask,
        showMessage:false,
        loading:'analyseLoading',
        data
      })
      if(res === 'ok') {
        this.getDetail()
      }else {
        // this.$message.warn('配方无解')
        this.$warning({
          title: '优化失败',
          // content: <div><span style="color: red;">配方无解,</span>请检查配方中原料或者营养需要量</div>,
          content:res.msg,
          okText: '确定'
        })
      }
    },
    async getDetail() {
      const res = await this.fetchGet({
        actions: this.formulataskDetail,
        name: 'details',
        data: {
          id: this.taskId,
        }
      });
      if (res && res.data) {
        //如果状态为97，则弹出确认提示信息
        if (res.data.status === 97) {
          this.$confirm({
            title: '系统提示',
            content: '任务中配方数据已失效,系统将重新同步,你确定操作吗?',
            okText: '确定',
            cancelButtonProps: {
              style: { display: 'none' }
            },
            closable: false, // 隐藏取消按钮
            onOk: async () => {
              //todo 同步数据
              const res = await this.fetchGet({
                actions: this.formulataskCacheInit,
                name: 'init',
                data: {
                  id: this.taskId,
                }
              });
              if (res && res.success) {
                this.refreshPage();
              }
            }
          });
        }else {
          let progressPercent = 0;
          let percentObj = { 11: 20, 12: 40, 14: 60, 13: 80, 15: 100 };
          let msgObj = { 11: '数据组装中', 12: '算法准备计算', 13: '结果保存中', 14: '算法计算中', 15: '算法计算完成', 2: '多配方有解', 4: '多配方有解，存在不可行配方', 88: '多配方优化失败', 99: '多配方优化失败' };
          let { status } = res.data || {};
          if (status === 11 || status === 12 || status === 13 || status === 14) {
            progressPercent = percentObj[status];
            this.setState({
              progressVisible: true,
              progressModalTitle: '梯度分析中',
              progressModalBtnText: '退出任务管理',
              progressModalContent: msgObj[status] || '梯度分析中',
              progressPercent,
            });
            setTimeout(() => {
              this.getDetail();
            }, 5000);
            this.setState({ detail: { ...res.data } });
          } else {
            let field = '';
            let title = '';
            if (status === 2 || status === 4 || status === 88 || status === 99) {
              if (status === 2 || status === 4) {
                field = 'success';
                title = '梯度分析优化完成，再次请求获取数据';
                //再次同步请求获取明细数据
                const res = await this.fetchPost({
                  actions: this.getSMultiSpeedFormulaTaskLadderFromRedis,
                  name: 'LadderFromRedis',
                  data: {
                    hashKey: this.taskId
                  }
                });
                if (res) {
                  this.result = res
                  this.$nextTick(()=>{
                    this.current++
                  })
                } else {
                  this.$error({
                    title: '梯度分析获取结果数据失败',
                    content: '请稍后重试',
                    okText: '知道了',
                    onOk: () => {
                      this.setState({
                        progressType: undefined,
                        progressVisible: false,
                        progressModalTitle: '',
                        progressModalBtnText: '',
                        progressModalContent: '',
                        progressPercent: 0,
                      });
                    }
                  })
                }
              }
              else if (status === 88 || status === 99) {
                field = 'warning';
                title = '梯度分析失败';
                this[`$${field}`]({
                  title,
                  content: msgObj[status],
                  okText: '知道了',
                  onOk: () => {
                    this.setState({
                      progressType: undefined,
                      progressVisible: false,
                      progressModalTitle: '',
                      progressModalBtnText: '',
                      progressModalContent: '',
                      progressPercent: 0,
                    });
                  }
                });
              }
              this.setState({
                progressVisible: false,
                progressModalTitle: '',
                progressModalBtnText: '',
                progressModalContent: '',
                progressPercent: 0,
              });

            } else if (status === 6) {
              await this.postSecAnalyse()
            }
          }
        }

      }
    },
    onClose(){
      this.$emit('close')
    },

    getResult(result){
      this.result = result
    },

    nextStep() {
      switch (this.current) {
        case 0:
          this.$refs['analyseForm'].postAnalyse()
          break;
        case 1:
          this.current++
        break
      }
    },

    prevStep() {
      this.current--
    },
    exportData(){
      if(this.$refs.analyseBase){
        let {analyseTable,analyseChart} = this.$refs.analyseBase.$refs
        if(analyseTable) analyseTable.downloadExcel()
        if(analyseChart) analyseChart.downloadChart()
      }
    }
  }
}
</script>


<style lang="scss" scoped>
  .footer{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
  }

  .containers{
    width:100%;
    flex:1;
    height: calc( 100vh - 100px);
  }
  ::v-deep .drawer{
    overflow: hidden;
    .ant-drawer-wrapper-body,.ant-drawer-wrapper-body{
      overflow: hidden;
    }
  }
</style>
